module.exports = "/static/assets/57507ecce9efed03229d8a5b626666a6.png";